<div class="domain-import-upload">
    <!-- File Upload Area -->
    <div 
        class="upload-area"
        [class.drag-over]="dragOver"
        [class.has-file]="selectedFile"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)">
        
        <div class="upload-content" *ngIf="!selectedFile">
            <i class="fas fa-cloud-upload-alt upload-icon"></i>
            <h4 class="upload-title" translate>Upload Domain Export File</h4>
            <p class="upload-description text-muted" translate>
                Drag and drop your JSON file here, or click to browse
            </p>
            <button 
                type="button" 
                class="btn btn-outline-primary browse-button" 
                (click)="triggerFileInput()"
                [disabled]="loading">
                <i class="fas fa-folder-open me-1"></i>
                <span translate>Browse Files</span>
            </button>
        </div>
        
        <input 
            type="file" 
            #fileInput
            accept=".json"
            (change)="onFileSelected($event)"
            class="file-input-hidden"
            [disabled]="loading">

        <!-- Selected File Display -->
        <div class="selected-file" *ngIf="selectedFile">
            <div class="file-info">
                <i class="fas fa-file-code file-icon"></i>
                <div class="file-details">
                    <h5 class="file-name">{{ selectedFile.name }}</h5>
                    <p class="file-size text-muted">{{ formatFileSize(selectedFile.size) }}</p>
                </div>
            </div>
            <button 
                type="button" 
                class="btn btn-outline-danger btn-sm"
                (click)="clearFile()"
                [disabled]="loading"
                title="Remove file">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>

    <!-- Error Display -->
    <div class="alert alert-danger mt-3" *ngIf="error">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ error }}
    </div>

    <!-- Loading State -->
    <div class="d-flex align-items-center justify-content-center mt-3" *ngIf="loading">
        <i class="fas fa-spinner fa-spin me-2"></i>
        <span translate>Processing file...</span>
    </div>

    <!-- JSON Format Information -->
    <div class="json-format-info mt-4">
        <h5 translate>JSON Format</h5>
        
        <div class="row">
            <div class="col-md-24">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0" translate>File Structure</h6>
                    </div>
                    <div class="card-body">
                        <p class="small" translate>Your JSON file should follow this structure:</p>
                        
                        <strong translate>Required Fields:</strong>
                        <ul class="small mb-2">
                            <li><strong>domains</strong> - <span translate>Array of domain objects</span></li>
                            <li><strong>domains[].url</strong> - <span translate>Domain URL</span></li>
                            <li><strong>domains[].title</strong> - <span translate>Domain title</span></li>
                        </ul>
                        
                        <strong translate>Optional Fields:</strong>
                        <ul class="small mb-2">
                            <li><strong>language</strong> - <span translate>Domain language code</span></li>
                            <li><strong>cms</strong> - <span translate>Content management system</span></li>
                            <li><strong>notes</strong> - <span translate>Domain description/notes</span></li>
                            <li><strong>labels</strong> - <span translate>Domain labels (array)</span></li>
                            <li><strong>domain_groups</strong> - <span translate>Domain group assignments (array)</span></li>
                            <li><strong>path_constraints</strong> - <span translate>URL path constraints (array)</span></li>
                            <li><strong>link_excludes</strong> - <span translate>Link exclusion patterns (array)</span></li>
                        </ul>
                        
                        <small class="text-muted" translate>Use the Domain Export feature to generate a properly formatted JSON file.</small>
                    </div>
                </div>
            </div>
            
            <div class="col-md-24">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0" translate>Example</h6>
                    </div>
                    <div class="card-body">
                        <pre class="mb-0">{{ '{' }}
  "exportVersion": "1.0",
  "exportedAt": "2023-10-03T12:00:00Z",
  "exportedBy": "user&#64;example.com",
  "domainCount": 2,
  "domains": [
    {{ '{' }}
      "url": "https://example.com",
      "title": "Example Domain",
      "language": "en",
      "cms": "custom",
      "notes": "Domain description",
      "labels": ["production"],
      "domain_groups": [],
      "path_constraints": [],
      "link_excludes": []
    {{ '}' }},
    {{ '{' }}
      "url": "https://example.org",
      "title": "Example Organization",
      ...
    {{ '}' }}
  ]
{{ '}' }}</pre>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="alert alert-info mt-3">
            <small>
                <strong translate>Note:</strong> 
                <span translate>JSON format exported from Domain Export is recommended. Maximum file size: 10MB. The file must contain valid domain data with proper structure.</span>
            </small>
        </div>
    </div>
</div>
